import { validators, z } from '../utils';
import { makeFormComponent, makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

const signUpFormSchema = z
  .object({
    confirmPassword: validators.password(),
    email: validators.email(),
    firstName: validators.requiredString('First name'),
    lastName: validators.requiredString('Last name'),
    password: validators.password(),
    phoneNumber: validators.e164PhoneNumber(),
    preferredName: validators.optionalString(),
    promoCode: validators.optionalString(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type SignUpFormSchema = InferFormType<typeof signUpFormSchema>;

export const signUpFormDefaultValues: SignUpFormSchema = {
  confirmPassword: '',
  email: '',
  firstName: '',
  lastName: '',
  password: '',
  phoneNumber: '',
  preferredName: '',
  promoCode: '',
};

export const useSignUpForm = makeFormHook(signUpFormSchema, signUpFormDefaultValues);

export const SignUpForm = makeFormComponent(signUpFormSchema, signUpFormDefaultValues);
